module.exports = __webpack_public_path__ + "img/6.d88133b8.png";